export class Message {
    constructor(role, content) {
        this.id = crypto.randomUUID()
        this.retry_count = 0
        this.role = role
        this.content = content
    }
}
